import * as z from "zod/v4";

export const getSessionHazardProbabilities = {
  name: "getSessionHazardProbabilities" as const,
  input: z.object({ sessionId: z.string() }),
  output: z
    .object({
      sessionId: z.string(),
      instantaneousHazardProbability: z.number(),
      cumulativeConversionProbability: z.number(),
      sessionAge: z.number(), // milliseconds since session start
      totalBuckets: z.number(),
    })
    .nullable(),
};
